<template>
  <el-container class="settings">
    <div class="headerCom" style="margin-bottom:0">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' :rightEventList="rightEventList" @rightFunc='rightFunc'
        v-on:getSearchObj='getSearchObj'>
      </publicExpandSearch>
    </div>
    <el-main class="tabs-table">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="启用" name="second"></el-tab-pane>
        <el-tab-pane label="停用" name="third"></el-tab-pane>
      </el-tabs>
      <!-- 列表数据 -->
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column label="序号" type="index" fixed> </el-table-column>
        <el-table-column label="用户名" prop="userName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="姓名" prop="realName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="性别" prop="gender" show-overflow-tooltip>
          <template slot-scope="scope">{{
              scope.row.gender == 1
                ? '男'
                : scope.row.gender == 2
                  ? '女'
                  : '未知'
          }}</template>
        </el-table-column>
        <el-table-column label="出生日期" prop="birthday" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="角色" prop="roleName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="归属" prop="belongTo" show-overflow-tooltip> </el-table-column>
        <el-table-column label="所属部门" prop="departmentName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="备注" prop="note" show-overflow-tooltip> </el-table-column>
        <el-table-column label="创建人ID" prop="createUserId" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" :formatter="statusFormatter" label="状态" prop="enabled" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="300" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="addUser(true, scope.row)">修改</el-button>
            <el-button type="text" size="mini" @click="seeinfo(scope.row)">查看详情</el-button>
            <el-button type="text" size="mini" @click="editJurisdiction(scope.row)">查看录入权限</el-button>
            <el-button v-if="scope.row.enabled == false" type="text" size="mini" @click="onload(scope.$index, scope.row)">
              启用</el-button>
            <el-button v-if="scope.row.enabled == true" type="text" size="mini" @click="offload(scope.$index, scope.row)">
              停用</el-button>
            <el-button type="text" size="mini" @click="resetpwd(scope.$index, scope.row)">分配角色</el-button>
            <el-button type="text" size="mini" slot="reference" @click="resectPwd(scope.$index, scope.row)">重置密码
            </el-button>
            <el-button size="mini" type="text" @click="delinfo(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="cardpage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchParams.current" :page-size="pageSize" layout="total,  prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-main>
    
    <!-- 查看详情弹出框 -->
    <div class="menulist-look-info">
      <el-drawer title="用户详情" :visible.sync="lookinfo">
        <el-form ref="form" :model="lookinfoobj" label-width="120px" size="mini">
          <el-form-item label="用户名:">
            {{ lookinfoobj.userName }}
          </el-form-item>
          <el-form-item label="姓名:">
            {{ lookinfoobj.realName }}
          </el-form-item>
          <el-form-item label="性别:">
            {{
                lookinfoobj.gender == 0
                  ? '未知'
                  : lookinfoobj.gender == 1
                    ? '男'
                    : lookinfoobj.gender == 2
                      ? '女'
                      : ''
            }}
          </el-form-item>
          <el-form-item label="出生日期:">
            {{ lookinfoobj.birthday }}
          </el-form-item>
          <el-form-item label="角色:">
            {{ lookinfoobj.roleName }}
          </el-form-item>
          <el-form-item label="所属部门:">
            {{ lookinfoobj.departmentName }}
          </el-form-item>
          <el-form-item label="备注:">
            {{ lookinfoobj.note }}
          </el-form-item>
          <el-form-item label="创建人ID:">
            {{ lookinfoobj.createUserId }}
          </el-form-item>
          <el-form-item label="创建时间:">
            {{ lookinfoobj.createTime }}
          </el-form-item>
          <el-form-item label="状态:">
            {{
                lookinfoobj.enabled == true
                  ? '启用'
                  : lookinfoobj.enabled == false
                    ? '停用'
                    : ''
            }}
          </el-form-item>
          <el-form-item label-width="300px">
            <el-button @click="lookinfo = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 分配角色弹出框 -->
    <div class="menulist-add">
      <el-drawer :visible.sync="drawer4" :with-header="false" class="drawer-box">
        <div class="title">分配角色</div>
        <el-tree :data="data" show-checkbox node-key="id" :default-expanded-keys="expankeys"
          :default-checked-keys="defachecked" :props="defaultPropsMenu" ref="menuTree" check-strictly>
        </el-tree>
        <el-button style="margin:20px 0 20px 20px" type="primary" @click="distributionon('ruleForm')">完成</el-button>
        <el-button @click="drawer4 = false">退出</el-button>
      </el-drawer>
    </div>
    <!-- 新 用户创建 -->
    <el-dialog :title="isEdit ? '修改用户' : '创建用户'" :visible.sync="userAddDialog" :width="jurisdiction ? '900px' : '500px'" center top="8vh">
      <div class="user-content">
        <div class="user-left">
          <div class="dialog-title">
            <div class="title-line"></div>
            <div class="title-tips">基本信息</div>
          </div>
          <!-- 新增 -->
          <div v-if="!isEdit">
            <el-form ref="forms" :model="info" :rules="rules" label-width="110px" size="small">
              <el-form-item label="姓名：" prop="realName">
                <el-input v-model="info.realName"></el-input>
              </el-form-item>
              <el-form-item label="身份证号码：" prop="idCard">
                <el-input v-model="info.idCard" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"></el-input>
              </el-form-item>
              <el-form-item label="手机号码：" prop="mobile">
                <el-input v-model="info.mobile" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"></el-input>
              </el-form-item>
            </el-form>
            <el-form ref="form" :model="account" :rules="rules" label-width="110px" size="small">
              <el-form-item label="账号：" prop="userName">
                <el-input v-model="account.userName" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')">
                </el-input>
              </el-form-item>
              <el-form-item label="密码：" prop="password">
                <el-input v-model="account.password" show-password onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')">
                </el-input>
              </el-form-item>
              <el-form-item label="录入权限：">
                <el-button plain @click="jurisdiction = !jurisdiction">编辑</el-button>
              </el-form-item>
              <el-form-item label="归属：" prop="belongTo">
                <el-radio-group v-model="account.belongTo" aria-multiline="" @change="changePlatform">
                  <el-radio label="plat">平台</el-radio>
                  <el-radio label="or">机构</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="机构：" prop="organization" v-if="account.belongTo == 'or'">
                <el-select v-model="account.organization" placeholder="请选择机构" filterable multiple value-key="id"
                  class="self-select" @change="changeAuth">
                  <el-option v-for="item in authList" :key="item.value" :label="item.name" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <!-- 修改 -->
          <el-form v-else :model="userinfolist" ref="editlist" :rules='rulesSet' label-width="110px"
            class="demo-ruleForm" size="small">
            <el-form-item label="ID" prop="id">
              <el-input v-model="userinfolist.id" disabled></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="userName">
              <el-input v-model="userinfolist.userName" disabled></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="realName">
              <el-input v-model="userinfolist.realName"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-select v-model="userinfolist.gender" placeholder="请选择活动区域">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期">
              <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
                  v-model="userinfolist.birthday" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="录入权限：">
              <el-button plain @click="jurisdiction = !jurisdiction">编辑</el-button>
            </el-form-item>
            <!-- <el-form-item label="手机号码" prop="mobile" size="mini">
            <el-input v-model="userinfolist.mobile"></el-input>
          </el-form-item> -->
            <el-form-item label="备注" prop="note">
              <el-input v-model="userinfolist.note"></el-input>
            </el-form-item>
            <el-form-item label="归属" prop="userState">
              <el-radio-group v-model="userinfolist.userState" :disabled="userinfolist.belongTo ? true : false"
                aria-multiline="" @change="changePlatform">
                <el-radio label="2">平台</el-radio>
                <el-radio label="1">机构</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="机构" prop="mechanismVOList" v-if="userinfolist.userState == '1'">
              <el-select v-model="userinfolist.mechanismVOList" :disabled="userinfolist.belongTo ? true : false"
                placeholder="请选择机构" multiple value-key="hospitalId" class="self-select" @change="changeAuth">
                <el-option v-for="item in authList" :key="item.hospitalId" :label="item.name" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addfatherliston('editlist')">完成</el-button>
              <el-button @click="drawer = false">退出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="user-right" v-show="jurisdiction">
          <div class="dialog-title">
            <div class="title-line"></div>
            <div class="title-tips">编辑录入权限</div>
          </div>
          <div class="search-jurisdiction">
            <el-input class="i-width" placeholder="请输入医院或科室" size="small" v-model.trim="hospitalSearch.hospitalName"
              clearable>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button size="small" style="margin-left: 20px;" @click="hospitalSearch.hospitalName = ''">重置</el-button>
            <el-button type="primary" size="small" @click="getOcrList(1)">搜索</el-button>
          </div>
          <el-scrollbar style="height: 100%;width:100%;overflow-x: hidden;margin-top: 20px;">
            <el-table ref="multipleTables" :data="jurisdictionUserList" tooltip-effect="dark" style="width: 100%"
              @selection-change="handleSelectionChange" @select="userSelect" @select-all="selectAll">
              <el-table-column type="selection">
              </el-table-column>
              <el-table-column label="医院">
                <template slot-scope="scope">{{ scope.row.hospitalName ? scope.row.hospitalName : '--' }}</template>
              </el-table-column>
              <el-table-column prop="name" label="科室">
                <template slot-scope="scope">{{ scope.row.name ? scope.row.name : '--' }}</template>
              </el-table-column>
            </el-table>
            <div style="height: 200px;"></div>
          </el-scrollbar>
        </div>
      </div>
      <div class="user-button" v-if="!isEdit">
        <el-button type="primary" size="small" @click="createon(account)">保存</el-button>
        <el-button size="small" @click="userAddDialog = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑录入权限弹窗 -->
    <el-dialog title="录入权限" :visible.sync="viewJurisdiction" width="30%" center top="8vh" @close="dialogClose">
      <div class="user-content" v-loading="viewLoading">
        <div class="user-right" style="margin: 0 auto;">
          <div class="search-jurisdiction">
            <el-input class="i-width" v-model.trim="perListSearch.hospitalName" placeholder="请输入医院或科室" size="small"
              clearable>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button size="small" style="margin-left: 20px;" @click="searchJurisdiction(2)">重置</el-button>
            <el-button type="primary" size="small" @click="searchJurisdiction(1)">搜索</el-button>
          </div>
          <el-scrollbar style="height: 100%;width:100%;overflow-x: hidden;margin-top: 20px;">
            <el-table :data="perLsit" tooltip-effect="dark" style="width: 100%">
              <el-table-column label="医院">
                <template slot-scope="scope">{{ scope.row.hospitalName ? scope.row.hospitalName : '--' }}</template>
              </el-table-column>
              <el-table-column prop="hospitalDepartmentName" label="科室">
                <template slot-scope="scope">{{ scope.row.hospitalDepartmentName ? scope.row.hospitalDepartmentName :
                    '--'
                }}</template>
              </el-table-column>
            </el-table>
            <div style="height: 200px;"></div>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template> 
<script>
import axios from "axios";
import local from "@/utils/local.js";

import {
  api_getuserinfo,
  api_ge_tuser_resoce_list,
  api_adduserinforesoce,
  api_create_user,
  api_del_user,
  api_update_userinfo,
  api_reset_pwd,
  getOcrSaveList,
  getPermissionList,
  put_permission
} from "@/api/userinfo.js";
import {
  api_getperuserinfo,
  api_department,
  api_get_role
} from "@/api/permissions.js";
import { plateFormAll, plateFormOn } from "@/api/acc.js";
const validMobile = (rule, value, callback) => {
  let reg = /^1[3456789]\d{9}$/;
  if (!value) {
    callback(new Error("请输入电话号码"));
  } else if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};

const validCardId = (rule, value, callback) => {
  let reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
  if (!value) {
    callback(new Error("请输入身份证号码"));
  } else if (!reg.test(value)) {
    callback(new Error("请输入正确的身份证号码"));
  } else {
    callback();
  }
};

export default {
  data() {
    return {
      breadList: [{ name: "系统设置" }, { name: "用户列表" }],
      searchList: [
        {
          label: "内容",
          paramName: "realName",
          inputType: "input"
        },
        {
          label: "归属",
          paramName: "belongTo",
          inputType: "hospital"
        },
        {
          label: "角色类型",
          paramName: "roleId",
          inputType: "select",
          optionData: [],
          remote: false
        },
        {
          label: "所属部门",
          paramName: "departmentId",
          inputType: "select",
          optionData: []
        },
        {
          label: "客户端选择",
          paramName: "clientId",
          inputType: "select",
          default: "dsicm-web-manager",
          optionData: [
            {
              label: "医生APP",
              value: "dsicm-app-doctor"
            },
            {
              label: "后台管理系统",
              value: "dsicm-web-manager"
            },
            {
              label: "患者小程序",
              value: "dsicm-wxapp-patient"
            }
          ]
        },
        {
          label: "创建时间",
          paramName: "upDateTime",
          stringTime: "upDateTime",
          inputType: "datetimerange",
          paramstartTime: "startTime",
          paramEndTime: "endTime",
          isTime: true
        }
      ],
      rightEventList: [{ eventName: "创建用户", eventValue: 1 }],
      searchParams: {
        current: 1,
        size: 10
      },
      viewLoading: false,
      isEdit: false,
      viewUserId: "",
      viewJurisdiction: false,
      jurisdictionUserList: [],
      jurisdiction: false,
      ocrPermissionDTOS: [], //录入权限数组
      hospitalSearch: {
        hospitalName: ""
      },
      perListSearch: {
        userId: "",
        hospitalName: null
      },
      perLsit: [],
      userAddDialog: false,
      authList: [],
      // /^1[3456789]\d{9}$/.test(phone)
      rules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCard: [{ required: true, trigger: "blur", validator: validCardId }],
        mobile: [{ required: true, trigger: "blur", validator: validMobile }],
        userName: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 6, max: 12, message: "账号必须在6~12位之间", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码必须在6~20位之间", trigger: "blur" }
        ],
        belongTo: [
          { required: true, message: "请选择归属", trigger: "change" }
        ],
        organization: [
          { required: true, message: "请选择机构", trigger: "change" }
        ]
      }, //添加用户验证规则
      rulesSet: {
        userState: [
          { required: true, message: "请选择归属", trigger: "change" }
        ],
        mechanismVOList: [
          { required: true, message: "请选择机构", trigger: "change" }
        ]
      },
      lookinfo: false, //查看用户
      pageSize: 10, //每页条数
      // currentPage: 1, // 初始显示那一页
      total: 0, // 总条数
      input: "", //搜索框
      value1: "", //日期选择 占位
      //mm66
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "7天内",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "3天内",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "一天内",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "全部",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 1800);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     }
      //   ]
      // }, //日期选择组件 时间差查询
      activeName: "first", //标签默认显示第一页全部
      tableData: [{ name: "1" }], //全部列表数据
      tableData1: [], //启用列表数据
      tableData2: [], //停用列表数据
      userinfolist: {
        userState: null,
        mechanismVOList: []
      },
      drawer: false, //查看信息弹出框
      defaultPropsMenu: {
        children: "children",
        label: "name"
      }, //改变权限树名字显示字段
      expankeys: [], //权限树默认展开数组
      lookinfoobj: {}, //查看用户数据对象
      defachecked: [], //权限树默认选中数组
      data: [], //权限树菜单
      drawer4: false, //分配角色弹出框
      ID: 1, //用户userid
      overarr: [], //选中状态子节点
      account: {
        password: "",
        userName: "",
        belongTo: "plat",
        organization: []
      }, //创建账号表单数据
      info: {
        realName: "",
        idCard: "",
        mobile: ""
      },
      roleId: "", //角色类型select
      roleIdList: [], //角色类型下拉列表
      hospitalNameList: [], //所属平台
      belongTo: "", //所属平台select
      departmentList: [], //部门列表
      departmentId: "", //所属部门select 占位
      enabled: null, //列表全部启用
      realName: "", //字段搜索
      startTime: "", //开始时间
      endTime: "", //结束时间
      client: "dsicm-web-manager",
      arr: [],
      flag: false,
      editObj: {
        userId: "",
        ocrPermissionDTOS: []
      }
    };
  },
  mounted() {
    this.getuserinfo();
    this.getrolesrouce();
    this.getDepartment();
    this.getRole();
    this.getPlateFormAll();
    this.plateFormOn();
  },
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getuserinfo();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.addUser(false);
      }
    },
    //单选
    userSelect(e, row) {
      console.log("触发单选");
      if (row.checked) {
        row.checked = false;
        let index = this.arr.findIndex(item => item.id == row.id);
        this.arr.splice(index, 1);
      } else {
        row.checked = true;
        this.arr.push(row);
        // this.arr = this.noRepeat(arr);
        // this.arr = this.arr.filter(item=>item.checked)
      }
      console.log("备用数组", this.arr);
    },
    //全选
    selectAll(e) {
      console.log("触发全选");
      if (e.length > 0) {
        this.jurisdictionUserList.forEach(item => {
          item.checked = true;
        });
        this.arr = this.jurisdictionUserList;
      } else {
        this.jurisdictionUserList.forEach(item => {
          item.checked = false;
        });
        this.arr = [];
      }
      console.log("备用数组", this.arr);
    },
    //选择录入权限
    handleSelectionChange(e) {},
    noRepeat(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr.length; j++) {
          if (arr[i].id == arr[j].id && i != j) {
            arr.splice(j, 1);
          }
        }
      }
      return arr;
    },
    getOcrList() {
      if (this.isEdit) {
        this.hospitalSearch.userId = this.editObj.userId;
      } else {
        this.hospitalSearch.userId = null;
      }
      getOcrSaveList({ ...this.hospitalSearch }).then(res => {
        this.jurisdictionUserList = res.data;
        let arr2 = [];
        this.jurisdictionUserList.forEach((item, index) => {
          if (this.arr.length > 0) {
            this.arr.forEach(itam => {
              if (item.id == itam.id) {
                this.jurisdictionUserList[index].checked = true;
                this.$nextTick(() => {
                  this.$refs.multipleTables.toggleRowSelection(item, true);
                });
              }
            });
          } else {
            console.log("第一次进来");
            if (item.checked) {
              this.$nextTick(() => {
                this.$refs.multipleTables.toggleRowSelection(item, true);
              });
              arr2.push(item);
            }
          }
        });
        this.arr = this.arr.concat(arr2);
        this.arr = this.noRepeat(this.arr);
      });
    },
    //查看权限
    editJurisdiction(row) {
      this.viewLoading = true;
      if (row) {
        this.viewUserId = row.userId;
        this.perListSearch.userId = this.viewUserId;
      }
      getPermissionList({ ...this.perListSearch }).then(res => {
        this.perLsit = res.data;
        this.viewLoading = false;
      });
      this.viewJurisdiction = true;
    },
    searchJurisdiction(type) {
      if (type == 1) {
        this.editJurisdiction();
      } else {
        this.viewUserId = "";
        this.perListSearch.hospitalName = null;
        this.editJurisdiction();
      }
    },
    dialogClose() {
      this.perListSearch.hospitalName = "";
    },
    //创建新用户按钮
    addUser(status, row) {
      this.arr = [];
      this.userAddDialog = true;
      this.isEdit = status;
      this.hospitalSearch.hospitalName = "";
      if (status) {
        //修改
        this.editObj.userId = row.userId;
        this.userinfolist = { ...row };
        if (this.userinfolist.userState) {
          this.userinfolist.userState = String(this.userinfolist.userState);
        }
        if (row.belongTo) {
          //2:平台
          if (this.userinfolist.userState == 2) {
            this.userinfolist.mechanismVOList = [];
          }
        } else {
          this.userinfolist.mechanismVOList = [];
        }
        if (this.userinfolist.gender == 1) {
          this.userinfolist.gender = "男";
        } else if (this.userinfolist.gender == 2) {
          this.userinfolist.gender = "女";
        } else {
          this.userinfolist.gender = "未知";
        }
      } else {
        //新增
        this.account = {
          password: "",
          userName: "",
          belongTo: "plat",
          organization: []
        };
        this.info = {
          realName: "",
          idCard: "",
          mobile: ""
        };
      }
      this.jurisdiction = false;
      this.getOcrList();
    },
    closeCreatDialog() {
      this.$refs["forms"].resetFields();
    },
    changeAuth(val) {},
    plateFormOn() {
      plateFormOn({}).then(res => {
        if (res.code == 0) {
          let end = res.data;
          end.map(item => {
            item.hospitalId = item.id;
          });
          this.authList = end;
        }
      });
    },
    getPlateFormAll() {
      plateFormAll({}).then(res => {
        if (res.code == 0) {
          let end = res.data;
          end.map(item => {
            if (!item.id) {
              item.id = item.companyId;
            }
            //  else {
            //   item.hospitalId = item.id;
            //   this.authList.push(item);
            // }
          });
          this.hospitalNameList = end;
        }
      });
    },
    //获取用户信息所有数据接口
    async getuserinfo() {
      this.searchParams.enabled = this.enabled;
      let res = await api_getuserinfo(
        //   {
        //   realName: this.realName,
        //   enabled: this.enabled,
        //   clientId: this.client,
        //   current: this.currentPage,
        //   departmentId: this.departmentId,
        //   startTime: this.startTime,
        //   endTime: this.endTime,
        //   roleId: this.roleId,
        //   belongTo: this.belongTo
        // }
        this.searchParams
      );
      this.total = res.data.total;
      this.tableData = res.data.records;
    },
    //搜素按钮
    // searchRedundant() {
    //   this.currentPage = 1;
    //   this.getuserinfo();
    // },
    //模糊字段搜索
    // redunlog(e) {
    //   this.currentPage = 1;
    //   this.realName = e;
    //   this.getuserinfo();
    // },
    //客户端下拉框change 事件
    clientChange(e) {
      this.client = e;
      this.getuserinfo();
    },
    //输入时间触发得到值
    dateinfo(val) {
      if (!val) {
        this.startTime = "";
        this.endTime = "";
        this.getuserinfo();
      } else {
        this.startTime = val[0];
        this.endTime = val[1];
        this.getuserinfo();
      }
    },
    //角色类型数据接口
    async getRole() {
      let res = await api_get_role();
      this.roleIdList = res.data;
      this.searchList[2].optionData = res.data.map(item => {
        return {
          label: item.name,
          value: item.id
        };
      });
    },
    //角色类型select change 事件
    roleIdChange(e) {
      // this.roleId = e;
      this.getuserinfo();
    },
    plateChange(val) {
      this.getuserinfo();
    },
    //所属部门接口数据
    async getDepartment() {
      let res = await api_department();
      this.departmentList = res.data;
      this.searchList[3].optionData = res.data.map(item => {
        return {
          label: item.name,
          value: item.id
        };
      });
    },
    //所属部门 change 事件
    departmentIdChange(e) {
      this.departmentId = e;
      this.getuserinfo();
    },
    //标签页点击切换
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.enabled = null;
      } else if (tab.name == "second") {
        this.enabled = 1;
      } else {
        this.enabled = 0;
      }
      this.searchParams.current = 1;
      this.getuserinfo();
    },
    //查看按钮
    seeinfo(row) {
      this.lookinfoobj = row;
      this.lookinfo = true;
    },
    //启用按钮
    onload(index, row) {
      axios.put(`/admin/user/enabled?userId=${row.userId}`).then(res => {
        if (res.data.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.getuserinfo();
        } else {
          this.$message.error("失败");
        }
      });
    },
    //停用按钮
    offload(index, row) {
      axios.put(`/admin/user/disabled?userId=${row.userId}`).then(res => {
        if (res.data.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.getuserinfo();
        } else {
          this.$message.error("失败");
        }
      });
    },
    //重置密码按钮
    async resectPwd(index, row) {
      this.$confirm("是否确认重置密码，重置后密码为Pass@1234", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_reset_pwd(row.userId);
        if (res.code == 0) {
          this.$message({
            message: "重置成功",
            type: "success"
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //删除按钮
    delinfo(index, row) {
      this.$confirm("是否要删除该用户", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_del_user(row.userId);
        if (res.code == 0) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getuserinfo();
        }
      });
    },
    //获取重置所有权限树列表接口
    async getrolesrouce() {
      let res = await api_getperuserinfo();
      this.data = res.data;
    },
    //获取权限树列表提交按钮
    async distributionon() {
      this.overarr = [];
      let resarr = this.$refs.menuTree.getCheckedNodes();
      resarr.forEach(item => {
        this.overarr.push(item.id);
      });
      if (!this.overarr.length) {
        this.$message.error("选择后提交");
      } else {
        let res = await api_adduserinforesoce({
          userId: this.ID,
          roleIdList: this.overarr
        });
        if (res.code == 0) {
          this.$message({
            message: "设置成功",
            type: "success"
          });
          this.drawer4 = false;
          this.getuserinfo();
        } else {
          this.$message.error(res.message);
        }
      }
    },
    //分配角色按钮
    async resetpwd(index, row) {
      this.defachecked = [];
      this.expankeys = [];
      this.drawer4 = true;
      this.ID = row.userId;
      this.getrolesrouce();
      let res = await api_ge_tuser_resoce_list({
        userId: row.userId
      });
      this.defachecked = res.data;
      this.expankeys = res.data;
    },
    // 当条数发生改变触发
    handleSizeChange(val) {
      this.searchParams.current = val;
      this.getuserinfo(); //重绘页面
    },
    // 当前页数发生改变
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.getuserinfo(); //重绘页面
    },
    //状态显示
    statusFormatter(row, column) {
      if (row.enabled == true) {
        return "启用";
      } else {
        return "停用";
      }
    },
    //修改用户信息弹窗框提交按钮
    addfatherliston(formName) {
      this.editObj.ocrPermissionDTOS = [];
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveUser();
        } else {
          return false;
        }
      });
    },
    async saveUser() {
      if (this.userinfolist.gender == "未知") {
        this.userinfolist.gender = 0;
      } else if (this.userinfolist.gender == "男") {
        this.userinfolist.gender = 1;
      } else if (this.userinfolist.gender == "女") {
        this.userinfolist.gender = 2;
      }
      let mechanismVOList = [];
      // userState 1:机构 2：平台
      if (this.userinfolist.userState == "2") {
        mechanismVOList.push({
          companyId: local.get("companyId") == 'null'?null:local.get("companyId"), //平台ID
          // hospitalId:local.get("hospitalId") == 'null'?null:local.get("hospitalId"), //线下机构id
          platformId:local.get("platformId") == 'null'?null:local.get("platformId") //互医机构id
        });
      } else {
        this.userinfolist.mechanismVOList.map(item => {
          mechanismVOList.push({
            companyId: local.get("companyId") == 'null'?null:local.get("companyId"), //平台ID
            hospitalId: item.hospitalId, //线下机构id
            platformId: item.platformId
          });
        });
      }
      console.log("最后提交时得数组", this.arr);
      this.arr.forEach(item => {
        let obj = {
          userId: this.editObj.userId,
          hospitalDepartmentId: item.id,
          hospitalDepartmentName: item.name,
          hospitalId: item.hospitalId,
          hospitalName: item.hospitalName
        };
        this.editObj.ocrPermissionDTOS.push(obj);
      });
      put_permission(this.editObj).then(res => {
        //console.log(res)
      });
      let res = await api_update_userinfo({
        id: this.userinfolist.id,
        userId: this.userinfolist.userId,
        realName: this.userinfolist.realName,
        note: this.userinfolist.note,
        mobile: this.userinfolist.mobile,
        gender: this.userinfolist.gender,
        birthday: this.userinfolist.birthday,
        mechanismVOList: mechanismVOList
      });
      if (res.code == 0) {
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.getuserinfo();
        this.userAddDialog = false;
      }
    },
    //创建用户弹窗提交
    createon() {
      this.$refs.forms.validate(valid => {
        this.$refs.form.validate(async valids => {
          if (valid && valids) {
            let mechanismVOList = [];
            if (this.account.belongTo == "plat") {
              mechanismVOList.push({
                companyId: local.get("companyId") == 'null'?null:local.get("companyId"), //平台ID
                // hospitalId: local.get("hospitalId") == 'null'?null:local.get("hospitalId"), //线下机构id
                platformId: local.get("platformId") == 'null'?null:local.get("platformId") //互医机构id
              });
            } else {
              this.account.organization.map(item => {
                mechanismVOList.push({
                  companyId: local.get("companyId"), //平台ID
                  hospitalId: item.id, //线下机构id
                  platformId: item.platformId
                });
              });
            }
            let arrs = [];
            this.arr.forEach(item => {
              let obj = {
                hospitalDepartmentId: item.id,
                hospitalDepartmentName: item.name,
                hospitalId: item.hospitalId,
                hospitalName: item.hospitalName
              };
              arrs.push(obj);
            });
            let res = await api_create_user({
              account: { ...this.account, mobile: this.info.mobile },
              info: this.info,
              mechanismVOList: mechanismVOList,
              ocrPermissionDTOS: arrs
            });
            if (res.code == 0) {
              this.account = this.$options.data().account;
              this.$message({
                message: "注册成功",
                type: "success"
              });
              this.userAddDialog = false;
              this.getuserinfo();
            } else {
              this.$message.error(res.message);
            }
          } else {
            return false;
          }
        });
      });
    },
    changePlatform(val) {}
  }
};
</script>


<style lang="less" scoped>
/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}

/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}

/deep/.el-table th {
  background: #fafafa;
}

/deep/ .el-tree {
  padding-top: 15px;
  padding-left: 10px;

  // 不可全选样式
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }

    .el-checkbox .el-checkbox__inner {
      display: none;
    }
  }
}

.el-select.self-select {
  width: 100%;
}

.settings {
  height: 100%;
  display: flex;
  flex-direction: column;
  .settings-top {
    display: flex;
    justify-content: space-between;

    .settings-topright {
      display: flex;

      .el-button {
        margin-left: 30px;
        margin-right: 30px;
      }
    }
  }

  .tabs-table {
    background: #fff;
    padding: 0 20px;
    margin: 16px;
  }

  .cardpage {
    text-align: right;
    padding: 30px 30px 20px;
    background: #fff;
  }

  .menulist-add {
    /deep/.drawer-box .el-drawer.rtl {
      overflow: auto;
    }

    .title {
      font-size: 26px;
      font-weight: bolder;
      color: blueviolet;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
}

.dialog-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .title-line {
    width: 4px;
    height: 15px;
    background-color: #1a7bfc;
    margin-right: 10px;
  }

  .title-tips {
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}

.user-content {
  display: flex;
  justify-content: space-between;

  .user-left {
    width: 80%;
    margin-right: 40px;
  }

  .user-right {
    width: 90%;
    max-height: 65vh;
    overflow: hidden;

    .search-jurisdiction {
      display: flex;
    }
  }
}

.user-button {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
</style>
